var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"add-remove-button",class:_vm.remove ? 'add-remove-button--remove' : 'add-remove-button--add',attrs:{"role":"button"}},_vm.$listeners),[(_vm.remove)?_c('Minus',{attrs:{"size":14}}):_c('Plus',{attrs:{"size":14}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }